const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context("@/assets/icons/svg", true, /\.svg$/)
requireAll(req)